import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { NUM_MAXIMO_INVERSORES } from "../constants";
import { Error } from "@mui/icons-material";

export function showMaxInvertersAlert(functionOnclose?: Function, functionOnConfirmation?: Function) {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: [`A quantidade máxima de um inversor é ${NUM_MAXIMO_INVERSORES} unidades.`, 'É necessário ajustar o campo de quantidade dos inversores.'],
    size: '440px',
    title: "Atenção!",
    yesText: 'OK',
    propagateWhenConfirm: true,
    subtitle:'Número máximo de inversores',
    onClose: () => {
      if(functionOnclose) functionOnclose();
      confirmationDialog.close();
    },
    onConfirmation: () => {
      if(functionOnConfirmation) functionOnConfirmation();
    },
    headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();
}